import React from 'react';
import { Box, CircularProgress, IconButton, LinearProgress, Tooltip } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import BookingCalendar from '../booking/BookingCalendar';
import BookingCalendarControls from '../booking/BookingCalendarControls';
import DashboardWorkspaceCard from './DashboardWorkspaceCard';
import {
  getDashboardWorkspaceIconButtonSx,
  getDashboardWorkspaceScrollSx,
} from '../../utils/dashboardWorkspaceLayout';

export default function DashboardCalendarWorkspace({
  themeMode = 'dark',
  displayView,
  currentDate,
  onViewChange,
  onDateChange,
  groupView,
  onGroupViewChange,
  gridDayCount,
  onGridDayCountChange,
  onQuickBook,
  onWebCheckIn,
  onOpenWebCheckInInvite,
  onCheckout,
  onCheckIn,
  onEventBlock,
  onHousekeeping,
  onDirtyRoomHousekeeping,
  pendingCleaningByRoomId = {},
  dataRevision = 0,
  boardRefreshKey = 0,
  boardRefreshing = false,
  onRefreshBoard,
  onBoardRefreshSettled,
}) {
  return (
    <DashboardWorkspaceCard
      themeMode={themeMode}
      title="Room Board"
      subtitle="Live room inventory for the selected date"
      denseHeader
      headerActions={
        <BookingCalendarControls
          variant="workspace"
          themeMode={themeMode}
          displayView={displayView}
          onViewChange={onViewChange}
          currentDate={currentDate}
          onDateChange={onDateChange}
          groupView={groupView}
          onGroupViewChange={onGroupViewChange}
          gridDayCount={gridDayCount}
          onGridDayCountChange={onGridDayCountChange}
          additionalActions={
            onRefreshBoard ? (
              <Tooltip title="Refresh room board">
                <span>
                  <IconButton
                    size="small"
                    onClick={onRefreshBoard}
                    disabled={boardRefreshing}
                    sx={getDashboardWorkspaceIconButtonSx(themeMode)}
                    aria-label="Refresh room board"
                  >
                    {boardRefreshing ? (
                      <CircularProgress size={16} />
                    ) : (
                      <RefreshIcon sx={{ fontSize: 18 }} />
                    )}
                  </IconButton>
                </span>
              </Tooltip>
            ) : null
          }
        />
      }
    >
      <Box sx={{ position: 'relative', flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        {boardRefreshing ? (
          <LinearProgress
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              zIndex: 2,
              height: 2,
              bgcolor: 'transparent',
              '& .MuiLinearProgress-bar': {
                bgcolor: '#4ce1b6',
                transition: 'transform 0.4s linear',
              },
            }}
          />
        ) : null}
        <Box
          sx={{
            ...getDashboardWorkspaceScrollSx(themeMode),
            p: { xs: 0.75, sm: 1 },
            opacity: boardRefreshing ? 0.72 : 1,
            transition: 'opacity 280ms ease',
            pointerEvents: boardRefreshing ? 'none' : 'auto',
          }}
          data-dashboard-room-board-root=""
        >
          <BookingCalendar
            displayView={displayView}
            currentDate={currentDate}
            onViewChange={onViewChange}
            onDateChange={onDateChange}
            groupView={groupView}
            theme={themeMode}
            gridDayCount={gridDayCount}
            onGridDayCountChange={onGridDayCountChange}
            onQuickBook={onQuickBook}
            onWebCheckIn={onWebCheckIn}
            onOpenWebCheckInInvite={onOpenWebCheckInInvite}
            onCheckout={onCheckout}
            onCheckIn={onCheckIn}
            onEventBlock={onEventBlock}
            onHousekeeping={onHousekeeping}
            onDirtyRoomHousekeeping={onDirtyRoomHousekeeping}
            pendingCleaningByRoomId={pendingCleaningByRoomId}
            dataRevision={dataRevision}
            boardRefreshKey={boardRefreshKey}
            onBoardRefreshSettled={onBoardRefreshSettled}
            layoutVariant="workspace"
          />
        </Box>
      </Box>
    </DashboardWorkspaceCard>
  );
}
